import {
  INVENTORY_LIST_REQUEST,
  INVENTORY_LIST_SUCCESS,
  INVENTORY_LIST_FAIL,
  INVENTORY_ADD_REQUEST,
  INVENTORY_ADD_SUCCESS,
  INVENTORY_ADD_FAIL,
  INVENTORY_ADD_RESET,
  INVENTORY_DELETE_REQUEST,
  INVENTORY_DELETE_SUCCESS,
  INVENTORY_DELETE_FAIL,
  INVENTORY_UPDATE_REQUEST,
  INVENTORY_UPDATE_SUCCESS,
  INVENTORY_UPDATE_FAIL,
  INVENTORY_UPDATE_RESET,
  INVENTORY_DETAILS_REQUEST,
  INVENTORY_DETAILS_SUCCESS,
  INVENTORY_DETAILS_FAIL,
  INVENTORY_SUMMARY_REQUEST,
  INVENTORY_SUMMARY_SUCCESS,
  INVENTORY_SUMMARY_FAIL,
  MULTI_INVENTORY_UPDATE_REQUEST,
  MULTI_INVENTORY_UPDATE_SUCCESS,
  MULTI_INVENTORY_UPDATE_FAIL,
  MULTI_INVENTORY_UPDATE_RESET
} from '../constants/inventoryConstants'

export const inventoryListReducer = (state = { inventory: [] }, action) => {
  switch (action.type) {
    case INVENTORY_LIST_REQUEST:
      return { ...state, loading: true }

    case INVENTORY_LIST_SUCCESS:
      return {
        loading: false,
        error: false,
        inventory: action.payload.inventory,
        pages: action.payload.pages,
        page: action.payload.page,
        count: action.payload.count
      }

    case INVENTORY_LIST_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const inventoryAddReducer = (state = {}, action) => {
  switch (action.type) {
    case INVENTORY_ADD_REQUEST:
      return { loading: true }

    case INVENTORY_ADD_SUCCESS:
      return { loading: false, success: true, addentry: action.payload }

    case INVENTORY_ADD_FAIL:
      return { loading: false, error: action.payload }

    case INVENTORY_ADD_RESET:
      return {}

    default:
      return state
  }
}

export const inventoryDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case INVENTORY_DELETE_REQUEST:
      return { loading: true }

    case INVENTORY_DELETE_SUCCESS:
      return { loading: false, success: true }

    case INVENTORY_DELETE_FAIL:
      return { loading: false, error: action.payload }

    default:
      return state
  }
}

export const inventoryUpdateReducer = (state = { unit: {} }, action) => {
  switch (action.type) {
    case INVENTORY_UPDATE_REQUEST:
      return { loading: true }

    case INVENTORY_UPDATE_SUCCESS:
      return { loading: false, success: true, unit: action.payload }

    case INVENTORY_UPDATE_FAIL:
      return { loading: false, error: action.payload }

    case INVENTORY_UPDATE_RESET:
      return { unit: {} }

    default:
      return state
  }
}

export const multiInventoryUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case MULTI_INVENTORY_UPDATE_REQUEST:
      return { loading: true }

    case MULTI_INVENTORY_UPDATE_SUCCESS:
      return { loading: false, success: true, sale: action.payload }

    case MULTI_INVENTORY_UPDATE_FAIL:
      return { loading: false, error: action.payload }

    case MULTI_INVENTORY_UPDATE_RESET:
      return {}

    default:
      return state
  }
}

export const inventoryDetailsReducer = (state = { unit: {} }, action) => {
  switch (action.type) {
    case INVENTORY_DETAILS_REQUEST:
      return { ...state, loading: true }
    case INVENTORY_DETAILS_SUCCESS:
      return { loading: false, success: true, unit: action.payload }
    case INVENTORY_DETAILS_FAIL:
      return { loading: false, uniterror: action.payload }
    default:
      return state
  }
}

export const inventoryResetReducer = (state = {}, action) => {
  switch (action.type) {
    case INVENTORY_ADD_RESET:
      return {}
    default:
      return state
  }
}

export const inventorySummaryReducer = (state = { summary: [] }, action) => {
  switch (action.type) {
    case INVENTORY_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case INVENTORY_SUMMARY_SUCCESS:
      return {
        loading: false,
        inventoryCount: action.payload.inventoryCount,
        lowInventoryCount: action.payload.lowInventoryCount,
        manufacturerCount: action.payload.manufacturerCount,
        itemCount: action.payload.itemCount,
        inventorycost: action.payload.inventorycost,
        inventoryvalue: action.payload.inventoryvalue
      }
    case INVENTORY_SUMMARY_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}
